import formManagerApiService from '../services/formManagerApiService';

export const getTemplatesPromise = (params) => {
    return new Promise((resolve, reject) => {
        formManagerApiService.getTemplates(params)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                reject(error);
            });
    });
};

export const createTemplatePromise = (data, baseTemplateId) => {
    return new Promise((resolve, reject) => {
        formManagerApiService.createTemplate(data, baseTemplateId)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                reject(error);
            });
    });
};

export const createTemplateVersionPromise = (templateId) => {
    return new Promise((resolve, reject) => {
        formManagerApiService.createTemplateVersion(templateId)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                reject(error);
            });
    });
};

export const saveTemplateVersionPromise = (data) => {
    return new Promise((resolve, reject) => {
        formManagerApiService.saveTemplateVersion(data)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                reject(error);
            });
    });
};

export const changeStatusFormPromise = (template) => {
    return new Promise((resolve, reject) => {
        formManagerApiService.changeStatusForm(template)
            .then(response => {
                resolve(response.data)
            })
            .catch(error => reject(error));
    });
};

export const getTemplateVersionPromise = (templateId, templateVersionId) => {
    return new Promise((resolve, reject) => {
        formManagerApiService.getTemplateVersion(templateId, templateVersionId)
            .then(response => resolve(response.data))
            .catch(error => reject(error));
    });
};

export const getTemplateVersionsPromise = (templateId) => {
    return new Promise((resolve, reject) => {
        formManagerApiService.getTemplateVersions(templateId)
            .then(response => resolve(response.data))
            .catch(error => reject(error));
    });
};

export const setTemplateVersionPromise = (templateId, version) => {
    return new Promise((resolve, reject) => {
        formManagerApiService.setTemplateVersion(templateId, version)
            .then(response => resolve(response.data))
            .catch(error => reject(error));
    });
};